// Korean
export const ko = {
  'app.name':           'Kardolive',
  'app.tagline':        '고객 포털',
  'app.signOut':        '로그아웃',

  'login.email':        '이메일',
  'login.password':     '비밀번호',
  'login.signIn':       '로그인',
  'login.signingIn':    '로그인 중…',
  'login.failed':       '로그인 실패',
  'login.newAccount':   'Kardolive가 처음이신가요?',
  'login.createAccount':'무료 계정 만들기 →',

  'nav.workspace':      '작업 공간',
  'nav.templates':      '템플릿',
  'nav.live':           '라이브',
  'nav.rooms':          '룸 및 채팅',
  'nav.content':        '콘텐츠',
  'nav.developer':      '개발자',
  'nav.account':        '계정',

  'nav.overview':       '개요',
  'nav.projects':       '프로젝트',
  'nav.chat':           '채팅 콘솔',
  'nav.sessions':       '세션',
  'nav.streams':        '라이브 스트림',
  'nav.studio':         '스튜디오',
  'nav.recordings':     '녹화',
  'nav.apiKeys':        'API 키',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook 테스터',
  'nav.networkTest':    '네트워크 테스트',
  'nav.embed':          '임베드 위젯',
  'nav.sdk':            'SDK 및 문서',
  'nav.docs':           '개발자 문서',
  'nav.analytics':      '분석',
  'nav.settings':       '설정',

  'overview.welcome':       '다시 오신 것을 환영합니다, {name}',
  'overview.plan':          '{tenant} · {plan} 요금제',
  'overview.newStream':     '새 스트림',
  'overview.kpi.live':           '지금 라이브',
  'overview.kpi.live.broadcasting': '스트림 방송 중',
  'overview.kpi.live.nothing':    '라이브 없음',
  'overview.kpi.total':           '총 스트림',
  'overview.kpi.total.sub':       '전체 기간',
  'overview.kpi.sessions':        '세션 · 30일',
  'overview.kpi.sessions.sub':    '게시 이벤트',
  'overview.kpi.recordings':      '녹화',
  'overview.kpi.recordings.sub':  '재생 준비 완료',
  'overview.recentStreams':       '최근 스트림',
  'overview.recentSessions':      '최근 세션',
  'overview.viewAll':             '모두 보기 →',
  'overview.empty.title':         '아직 스트림이 없습니다',
  'overview.empty.body':          '방송을 시작하려면 첫 번째 스트림을 만드세요.',
  'overview.empty.action':        '스트림 만들기',
  'overview.noSessions':          '아직 세션이 없습니다',

  'status.live':        '라이브',
  'status.idle':        '유휴',
  'status.ended':       '종료',
  'status.archived':    '보관됨',

  'common.save':        '저장',
  'common.cancel':      '취소',
  'common.delete':      '삭제',
  'common.edit':        '편집',
  'common.create':      '생성',
  'common.confirm':     '확인',
  'common.loading':     '로딩 중…',
  'common.error':       '오류',
  'common.retry':       '다시 시도',

  // Dashboard navigation and account controls.
  "nav.skipContent": "페이지 콘텐츠로 이동",
  "nav.streamTemplates": "방송 템플릿",
  "nav.boards": "인터랙티브 보드",
  "nav.menu": "탐색 메뉴 열기",
  "nav.closeMenu": "탐색 메뉴 닫기",
  "nav.scenarios": "활용 시나리오",
  "nav.premieres": "최초 공개",
  "nav.clips": "클립",
  "dashboard.account": "계정",
  "dashboard.language": "언어",
  "dashboard.appearance": "화면 설정",
  "nav.allStreams": "모든 방송",
  "nav.destinations": "송출 대상",
  "nav.ecommerce": "전자상거래",
  "nav.products": "상품",
  "nav.services": "서비스",
  "nav.collections": "컬렉션",
  "nav.orders": "주문",
  "nav.commerceSettings": "상거래 설정",
  "nav.engagement": "참여",
  "theme.light": "라이트 모드로 전환",
  "theme.dark": "다크 모드로 전환",
  "role.owner": "소유자",
  "role.admin": "관리자",
  "role.member": "멤버",
  "role.viewer": "열람자",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "사용 중",
  "streams.archived": "보관됨",
  "streams.monitor": "송출 소스 모니터",
  "streams.create": "라이브 방송 만들기",
  "streams.list": "목록",
  "streams.grid": "격자",
  "streams.view": "방송 보기 방식",
  "streams.searchLabel": "이벤트 검색",
  "streams.searchHint": "이벤트 이름으로 검색",
  "streams.solutionFilter": "유형별 이벤트 필터",
  "streams.statusFilter": "상태별 이벤트 필터",
  "streams.dateFilter": "생성일별 이벤트 필터",
  "streams.allSolutions": "모든 유형",
  "streams.custom": "기존 또는 사용자 지정 설정",
  "streams.allStatuses": "모든 상태",
  "streams.anyTime": "모든 생성일",
  "streams.last7": "최근 7일 이내 생성",
  "streams.last30": "최근 30일 이내 생성",
  "streams.count": "전체 {total}개 중 {shown}개 이벤트 표시",
  "streams.noMatch": "필터에 맞는 이벤트가 없습니다.",
  "streams.clearFilters": "필터 초기화",
  "streams.refreshFailed": "방송 목록을 새로 고칠 수 없습니다",
  "streams.loadFailed": "방송을 불러올 수 없습니다",
  "streams.stale": "마지막으로 불러온 목록입니다. 상태가 바뀌었을 수 있습니다.",
  "streams.connectionHint": "연결을 확인하고 목록을 다시 불러오세요.",
  "streams.retrying": "다시 시도 중…",
  "streams.retry": "다시 시도",
  "streams.restoreFailed": "방송을 복원할 수 없습니다",
  "streams.restoreHint": "연결을 확인하고 목록을 새로 고쳐 최신 상태를 확인한 후 다시 시도하세요.",
  "streams.unused": "사용하지 않은 방송: {count}개",
  "streams.unusedHint": "방송 이력이나 다시보기가 없습니다. 보관하여 목록을 정리하세요. 아무것도 삭제되지 않습니다.",
  "streams.reviewArchive": "검토 후 보관",
  "streams.loading": "방송을 불러오는 중…",
  "streams.archiveEmpty": "보관된 방송이 없습니다. 보관된 방송과 다시보기는 복원할 때까지 여기에 유지됩니다.",
  "streams.restore": "복원",
  "streams.firstTitle": "첫 방송을 만들어 보세요",
  "streams.firstBody": "판매, 수업, 서비스용 설정을 선택하거나 빈 방송으로 시작하세요. 브라우저, 휴대전화 또는 OBS로 방송할 수 있습니다.",
  "streams.blank": "빈 방송",
  "streams.broadcasts": "방송 횟수: {count}",
  "streams.replays": "다시보기: {count}개",
  "streams.sessions": "세션: {count}개",
  "streams.recordings": "녹화: {count}개",
  "streams.mode.BROADCAST": "방송",
  "streams.mode.LOW_LATENCY": "저지연",
  "streams.mode.REALTIME": "실시간",
  "streams.key": "키",
  "streams.archiveTitle": "사용하지 않은 방송 보관",
  "streams.archiveHint": "한 번도 송출하지 않은 방송입니다. 보관됨 탭에서 언제든지 복원할 수 있습니다.",
  "streams.archiveFailed": "방송 {count}개를 보관할 수 없습니다. 이미 시작되었을 수 있습니다. 나머지는 보관했습니다.",
  "streams.archiving": "보관 중…",
  "streams.archiveCount": "{count}개 보관",
  "streamType.webinar": "비즈니스 웨비나 및 출시 행사",
  "streamType.classroom": "수업 및 개인 지도",
  "streamType.training": "기업 교육",
  "streamType.conference": "컨퍼런스 및 전시회",
  "streamType.shopping": "라이브 쇼핑",
  "streamType.auction": "라이브 경매",
  "streamType.consultation": "비공개 상담",
  "streamType.creator": "크리에이터 및 커뮤니티 방송",
  "streamType.audio": "오디오 룸 및 팟캐스트",
  "streamType.sports": "스포츠 및 e스포츠",
  "streamType.performance": "콘서트 및 공연",
  "streamType.community": "예배 및 모금",
  "streamType.tour": "투어 및 시연",
  "streamType.fitness": "피트니스 및 워크숍",
  "streamType.public-meeting": "뉴스 및 공개 회의",
  "streamType.continuous": "상시 채널 및 카메라",
  "streams.close": "닫기",
};
